export {
  deferCall
};

function deferCall(cb) {
  let timer;
  return function(){
    clearTimeout(timer);
    timer = setTimeout(() => {
      cb.apply(null, arguments);
    });
  }
}
